// Key format: livechat_[SERVICE]_[LOCATION]_[SPECIFIER]
export const EngagementKeys = {
  default: '',
  // Beauty
  livechat_beauty_drawer: 'livechat_beauty_drawer',
  livechat_beauty_header: 'livechat_beauty_header',
  livechat_beauty_footer: 'livechat_beauty_footer',
  livechat_beauty_contentblock: 'livechat_beauty_contentblock',
  livechat_beauty_contact: 'livechat_beauty_contact',
  livechat_beauty_services: 'livechat_beauty_services',
  // Support
  livechat_support_drawer: 'livechat_support_drawer',
  livechat_support_footer: 'livechat_support_footer',
  livechat_support_contact: 'livechat_support_contact',
  // Default override
  livechat_default_page: 'livechat_default_page'
} as const;
